import { UnicodeEntity } from '@mews/enums';
import { Time, TimeService, DateTimeLocalizationInfo } from '@mews/framework/datetime';

interface timesToLocalizedTimeRangeOptions {
    startTime: Time;
    endTime: Time;
    localizationInfo: DateTimeLocalizationInfo;
}

/**
 * @returns Usually 3:00 PM ‐ 12:00 PM for en-US, but it depends on localization info.
 */
export const getTimeRange = ({ startTime, endTime, localizationInfo }: timesToLocalizedTimeRangeOptions) =>
    [
        TimeService.toShortString(startTime, localizationInfo),
        UnicodeEntity.NoBreakSpace,
        UnicodeEntity.Dash,
        UnicodeEntity.NoBreakSpace,
        TimeService.toShortString(endTime, localizationInfo),
    ].join('');
